import { useMemo } from 'react';
import type { VoidFunctionComponent } from 'react';

import { Status } from '../../../../../shared/dependenciesV2';
import Locator from '../../../../../shared/Locator';
import List from '../../../generic/List';
import { DetailsRow } from '../../dependenciesV2/DependenciesTable/DependencyTableRow/DetailsRow';
import { getStatusFromDependencyState } from '../../dependenciesV2/DependenciesTable/DependencyTableRow/helpers';
import type { DependencyForAPI } from '../../../../../shared/dependenciesV2/response';
import type { Fetcher } from '../../../../../shared/fetchers';

import VendoredDependencyRowTitle from './VendoredDependencyRowTitle';

// import styles from './VendoredDependencyRow.module.less';

type Props = {
  dependency: DependencyForAPI;
};

/**
 * Renders a row for a vendored dependency.
 */
const VendoredDependencyRow: VoidFunctionComponent<Props> = ({
  dependency,
}) => {
  //  Parse the locator to extract fetcher and package information,
  //  with reasonable defaults.
  const { fetcher, packageName, version, locatorFull } = useMemo(() => {
    const loc = new Locator(dependency.locator);

    const locFetcher = (loc.fetcher.value || 'unknown') as Fetcher;
    const locPackage = dependency.title || loc.package.value || ''; //
    const locVersion = dependency.version || loc.revision.value || '';
    return {
      fetcher: locFetcher,
      packageName: locPackage,
      version: locVersion,
      locatorFull: loc.toFullString(),
    };
  }, [dependency.locator, dependency.title, dependency.version]);

  // Get the status of the dependency
  const status = getStatusFromDependencyState(dependency.status);

  return (
    <List.RowContainer>
      <List.Row hasTightPadding>
        <VendoredDependencyRowTitle
          depth={dependency.depth}
          fetcher={fetcher}
          packageName={packageName}
          version={version}
          locatorFull={locatorFull}
        />
        {status === Status.Analyzed && (
          <DetailsRow
            dependency={dependency}
            isReleaseGroupScope={false}
          />
        )}
      </List.Row>
    </List.RowContainer>
  );
};

export default VendoredDependencyRow;
